import React from 'react';

import AvatarSkeleton from '@atlaskit/avatar/Skeleton';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

import {
	ActivityContextAndContributors,
	ActivityMetaInfo,
	ActivityNameAndMetaInfo,
	IconAndActivityWrapper,
	Row,
} from './styled';

export interface RecentWorkSkeletonRowProps {
	/** Boolean indicating to include a skeleton of avatars for contributors on the row */
	hasAvatar?: boolean;
}

const RecentWorkSkeletonRow = ({ hasAvatar }: RecentWorkSkeletonRowProps): React.JSX.Element => {
	return (
		<Row>
			<IconAndActivityWrapper>
				{/*wrapping avatar skeleton in a div stops it from shrinking at smaller screen sizes*/}
				<div>
					<AvatarSkeleton appearance="square" size="xxsmall" />
				</div>

				<ActivityNameAndMetaInfo>
					<Box paddingInlineStart="space.200">
						<Skeleton isShimmering width="100%" height={8} />
					</Box>

					<ActivityMetaInfo>
						<Box paddingInlineStart="space.200">
							<Skeleton isShimmering width={60} height={8} />
						</Box>
						<Box paddingInlineStart="space.150">
							<Skeleton isShimmering width={60} height={8} />
						</Box>
					</ActivityMetaInfo>
				</ActivityNameAndMetaInfo>
			</IconAndActivityWrapper>

			<ActivityContextAndContributors>
				<Skeleton isShimmering width={150} height={8} />
				{hasAvatar && <AvatarSkeleton />}
			</ActivityContextAndContributors>
		</Row>
	);
};

export default RecentWorkSkeletonRow;
